import { Md } from "@client/component/Modal";
import { Style } from "@client/style";
import { css } from "@emotion/css";
import { Card, Form } from "antd";
import React from "react";

export function FormWrapper({ children }: { children }) {
  return (
    <Card
      className={css`
        margin: 2rem auto 0;
        max-width: ${Md.pageWidth};
        max-height: 90vh;
        overflow: auto;
        box-shadow: ${Style.shadowNormal};
        border-radius: 0.4rem;
      `}
    >
      <Form style={{ padding: "1rem" }} labelCol={{ style: { width: "7rem" } }}>
        {children}
      </Form>
    </Card>
  );
}
